import { Box, Heading, useTheme } from '@hover/blueprint';
import type { BoxProps } from '@hover/blueprint/chakra';
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
} from '@hover/blueprint/chakra';
import React, { useState } from 'react';

import { PROJECT_DETAILS_PADDING } from './ProjectCardSection';

type ExpandedIndex = 0 | -1;

interface ProjectAccordionProps {
  children: React.ReactNode;
  defaultOpen?: boolean;
  disabled?: boolean;
}

export const ProjectAccordion = ({
  children,
  defaultOpen,
  disabled,
}: ProjectAccordionProps) => {
  const [index, setIndex] = useState<ExpandedIndex>(
    defaultOpen && !disabled ? 0 : -1,
  );

  const handleChange = (value: ExpandedIndex) => {
    setIndex(disabled ? -1 : value);
  };

  return (
    <Accordion allowToggle index={index} onChange={handleChange}>
      <AccordionItem>
        <Box flexDirection="column" gap={500}>
          {children}
        </Box>
      </AccordionItem>
    </Accordion>
  );
};

export const ProjectAccordionHeader = ({ label }: { label: string }) => {
  const t = useTheme();
  return (
    <Heading
      mb={0}
      mr={100}
      mt={300}
      px={PROJECT_DETAILS_PADDING}
      size={100}
      sx={{
        '& button': {
          background: 'none',
          border: 'none',
          borderRadius: '5px',
          color: 'neutral.900',
          cursor: 'pointer',
          display: 'flex',
          fontWeight: 700,
          justifyContent: 'space-between',
          fontSize: t.fontSizes[200],
        },
      }}
    >
      <AccordionButton>
        {label}
        <AccordionIcon />
      </AccordionButton>
    </Heading>
  );
};

type ProjectAccordionPanelProps = BoxProps;

export const ProjectAccordionPanel = ({
  children,
  ...props
}: ProjectAccordionPanelProps) => (
  <AccordionPanel>
    <Box flexDirection="column" gap={500} {...props}>
      {children}
    </Box>
  </AccordionPanel>
);
